module.exports = __webpack_public_path__ + "static/img/active2.c145ad72.png";